import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import CssBaseline from '@mui/material/CssBaseline';
import MContainer from '@mui/material/Container';
import HomePage from './pages/home';
import GamePage from './pages/game';
import GameMode from './pages/game-mode';
import Ranking from './pages/ranking/index';
import MyProfile from './pages/my-profile';
import Settings from './pages/settings';
import HowToPlay from './pages/how-to-play';
import "./App.scss";

function App() {
  return (
    <React.Fragment>
    <CssBaseline />
    <MContainer className="container" maxWidth="md">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/game" element={<GamePage />} />
          <Route path="/game-mode"  element={<GameMode />} />
          <Route path="/ranking" element={<Ranking/>} />
          <Route path="/myprofile" element={<MyProfile/>} />
          <Route path="/settings" element={<Settings/>} />
          <Route path="/howtoplay" element={<HowToPlay/>} />
        </Routes>
      </Router>
    </MContainer>
  </React.Fragment>
  );
}

export default App;
